var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2241.58,-459.972)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5,0,0,5.37313,1345.63,-384.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "matrix(0.208333,1.54081e-32,-2.56802e-33,0.208333,130.648,136.662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.573,104.353C260.362,104.353 261,104.995 261,105.787L261,120.565C261,121.357 260.362,122 259.573,122L234.43,122C233.64,122 233,121.357 233,120.565L233,105.787C233,104.995 233.64,104.353 234.43,104.353L259.573,104.353ZM236.226,102.564C235.798,102.564 235.451,102.216 235.451,101.786C235.451,101.358 235.798,101.01 236.226,101.01L257.837,101.01C258.265,101.01 258.611,101.358 258.611,101.786C258.611,102.216 258.265,102.564 257.837,102.564L236.226,102.564ZM238.096,99.555C237.71,99.555 237.395,99.241 237.395,98.852L237.395,98.703C237.395,98.315 237.71,98 238.096,98L255.638,98C256.024,98 256.338,98.315 256.338,98.703L256.338,98.852C256.338,99.241 256.024,99.555 255.638,99.555L238.096,99.555Z",
    style: {
      fill: "rgb(51,57,68)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity_icon.60c9a6fe632efafb7451470e4692071e.svg";
export { ForwardRef as ReactComponent };